(() => {
function $ddabfb57f9d78fd9$var$clearBasicViewItemActive() {
    var item = document.querySelector(".form-pict.show");
    if (item) item.classList.remove("show");
    var item = document.querySelector(".view-menu ul li a.active");
    if (item) item.classList.remove("active");
}
function $ddabfb57f9d78fd9$var$changeBasicViewItem(item, manual) {
    // if manual -> stop interval
    if (manual) $ddabfb57f9d78fd9$var$indexBasics = -1;
    $ddabfb57f9d78fd9$var$clearBasicViewItemActive();
    if (item) {
        item.classList.toggle("active");
        var img = document.querySelector(`#basics-${item.dataset["type"]}`);
        img.classList.add("show");
    }
}
// expose the fn in global scope for inline use
window.changeBasicViewItem = $ddabfb57f9d78fd9$var$changeBasicViewItem;
var $ddabfb57f9d78fd9$var$indexBasics = 1;
setInterval(()=>{
    if ($ddabfb57f9d78fd9$var$indexBasics >= 0 && document.querySelectorAll(".view-menu ul li a")) {
        var items = document.querySelectorAll(".view-menu ul li a");
        $ddabfb57f9d78fd9$var$changeBasicViewItem(items[$ddabfb57f9d78fd9$var$indexBasics]);
        $ddabfb57f9d78fd9$var$indexBasics++;
        if ($ddabfb57f9d78fd9$var$indexBasics >= items.length) $ddabfb57f9d78fd9$var$indexBasics = 0;
    }
}, 5000);

})();
//# sourceMappingURL=index.js.map
